

import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormControl,
} from '@angular/forms';

import {
  catchError,
  delay,
  switchMap,
  tap,
} from 'rxjs/operators';

import {
  Observable,
  Subscriber,
  of,
  throwError,
} from 'rxjs';

import {
  CustomFormControlWithField,
  CustomFormGroup as CustomFormGroupNew,
  ToggleField,
} from '@rs-bank/rs-forms-extention';
import {
  Column,
  FieldBoxForCustomFormControl,
  Form,
  Section,
} from '@rs-bank/rs-layout';
import { Button } from '@rs-bank/rs-layout';

 
import {
  BiometricsRegistrationRejectException,
  InternetbankAppApplicationException,
  OperationConfirmationRequiredException,
} from '../../../../common/exceptions/exceptions';
import { WizardDataStep } from '../../../../shared/wizard-v2/wizard-core/steps/base-step-types/wizard-data-step';
import { Systems } from '../../../authorization.service';
import { BiometricsRegistrationWizardComponent } from '../biometrics-registration-wizard.component';
import {
  BiometricsRegistrationCreateRequestAgreement,
  BiometricsRegistrationCreateResponse,
  CreateSessionResponse,
} from '../biometrics-registration-wizard.service';
import { BiometricsRegistrationSecondStepData } from '../models/biometrics-registration-second-step.data';
import { MainCondition, PreloginProduct } from '../models/models';


export class BiometricsRegistrationSecondStep extends WizardDataStep<BiometricsRegistrationWizardComponent, BiometricsRegistrationSecondStepData> {

	public override newForm: CustomFormGroupNew<{
		mainToggle: boolean;
		toggles: Array<BiometricsRegistrationCreateRequestAgreement>;
	}>;

	public onInit(data: BiometricsRegistrationSecondStepData): Observable<void> {

		this.wizard.options.goBackInvisible = false;

		return this.createInitialForm(data.preloginProduct);
	}


	public onExecute(): Observable<BiometricsRegistrationCreateResponse> {

		return this.wizardComponent.biometricsRegistrationWizardService.createSession({
			sysName: Systems.INTERNETBANK,
			firstName: this.stepInitializationData.biomerticsClientData.firstName,
			lastName: this.stepInitializationData.biomerticsClientData.lastName,
			patronymic: this.stepInitializationData.biomerticsClientData.secondName,
			mobileNumber: this.stepInitializationData.biomerticsClientData.phone,
			productId: this.stepInitializationData.preloginProduct.productId,
			deviceId: navigator.userAgent,
		})
			.pipe(
				 
				switchMap((session: CreateSessionResponse) => this.wizardComponent.biometricsRegistrationWizardService.create({
					// eslint-disable-next-line @typescript-eslint/typedef
					agreements: this.newForm.getCustomFormControl(c => c.toggles)?.value,
				})),
				catchError((error: InternetbankAppApplicationException) => {
					if (!(error instanceof OperationConfirmationRequiredException)) {
						this.wizardComponent.biometricsRegistrationErrorPopUpComponent.exception = new BiometricsRegistrationRejectException();
						this.wizardComponent.biometricsRegistrationErrorPopUpComponent.showPopUp();

						this.wizardComponent.biometricsRegistrationPopUpComponent.close();
					}

					return throwError(error);
				}),
			);
	}

	private createInitialForm(data: PreloginProduct): Observable<void> {
		return new Observable((subscriber: Subscriber<void>) => {

			this.stepInformation.setSubmitLabel('Подтвердить');
			this.stepInformation.isAvailableSubmitButton$$.next(true);

			this.newForm = new CustomFormGroupNew({
				mainToggle: new CustomFormControlWithField({}),
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				toggles: new UntypedFormArray([]) as unknown as AbstractControl<any, any>,
			});

			this.newForm;

			const mainToggleAnimationDelay = 356;

			// eslint-disable-next-line @typescript-eslint/typedef
			(this.newForm as CustomFormGroupNew).getCustomFormControl(c => c.mainToggle).valueChanges
				.pipe(
					delay(mainToggleAnimationDelay),
					tap((data: unknown) => {
						// eslint-disable-next-line @typescript-eslint/typedef
						const formArray = ((this.newForm as CustomFormGroupNew).getCustomFormControl(c => c.toggles) as unknown as UntypedFormArray);

						for (let index = 0; index < formArray.length; index++) {

							const toggleForm = formArray.at(index) as CustomFormGroupNew<BiometricsRegistrationCreateRequestAgreement>;
							if (data) {
								toggleForm.enable();
								// eslint-disable-next-line @typescript-eslint/typedef
								toggleForm.getCustomFormControl(c => c.isAgree).setValue(true);
							} else {
								toggleForm.disable();
								// eslint-disable-next-line @typescript-eslint/typedef
								toggleForm.getCustomFormControl(c => c.isAgree).setValue(false);
							}

							const isAgreeCustomFormControlNew = (toggleForm as unknown as CustomFormGroupNew).controls.isAgree as CustomFormControlWithField;
							if (isAgreeCustomFormControlNew.fieldContext.getFieldComponentRef) {
								isAgreeCustomFormControlNew.fieldContext.getFieldComponentRef?.()?.component?.detectChanges();
							}

						}

					}))
				.subscribe();

			this.layoutForm = new Form(
				undefined,
				new Column([

					new Section(
						'',
						new Column([

							new FieldBoxForCustomFormControl(
								// eslint-disable-next-line @typescript-eslint/typedef
								(this.newForm as CustomFormGroupNew).getCustomFormControl(c => c.mainToggle),
								new ToggleField({label: 'Я Подтверждаю все нижеизложенное'}),
							),
							...data.mainConditions.map((mainCondition: MainCondition) => {

								const toggleControl = new CustomFormControlWithField({});
								toggleControl.disable();

								const agreementForm = new CustomFormGroupNew<BiometricsRegistrationCreateRequestAgreement>(
									{
										code: new UntypedFormControl(mainCondition.docType),
										isAgree: toggleControl,
									},
								);


								// eslint-disable-next-line @typescript-eslint/typedef
								((this.newForm as CustomFormGroupNew).getCustomFormControl(c => c.toggles) as unknown as UntypedFormArray).push(agreementForm);


								const createLabel = (mainCondition: MainCondition) => {
									if (mainCondition.link) {
										return `<a class="link" target="_blank" href="${mainCondition.link}">${mainCondition.text}</a>`;
									}
									return mainCondition.text;
								};

								return new FieldBoxForCustomFormControl(
									toggleControl as CustomFormControlWithField,
									new ToggleField({label: createLabel(mainCondition)}),
								);
							}),

							new Button(
								'Условия заключаемых договоров',
								() => {
									this.wizardComponent.isOpenConditions = true;
								},
								of(false),
								{cssClassList: ['biometrics-registration__conditions-button']},
							),

						]),
						{cssClassList: ['biometrics-registration__section']},
					),

				], {
					name: 'biometrics-registration__column',
					cssClassList: ['biometrics-registration__column'],
				}),
				undefined,
			);

			subscriber.next();
		});
	}


}
